export const unloadAsset = (url, app) => {
    const asset = app.assets.find(url.split('/').pop());
    asset?.unload();
};

export const isDesktop = () => {
    return (window.innerWidth / window.innerHeight) > 1;
    // const realWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    // if width is greater than tailwind lg breakpoint
    // return realWidth > 1280;
};